import { useState } from "react";
import { ThumbsUp } from "lucide-react";
import { Button } from "@mui/material";

export default function LikeButton({ data, updateblog, post }) {
  const [liked, setLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(data);

  console.log(data);

  const handleLike = async () => {
    if (!liked) {
      setLikeCount(likeCount + 1);
      setLiked(true);

      const url = "https://rohan-tax-services.onrender.com/api/auth/likeblog";
      const respone = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: post._id,
        }),
      });

      if (respone.ok) {
        updateblog();
      }
    }
  };

  return (
    <Button
      variant="outlined"
      onClick={handleLike}
      disabled={liked}
      className={`flex items-center space-x-2 ${
        liked
          ? "bg-green-100 text-blue-800 border-blue-500"
          : "bg-gray-100 text-[#151C62] border-blue-500"
      }`}
      sx={{
        color: "#151C62",
      }}
    >
      <ThumbsUp
        className={`w-5 h-5 ${liked ? "fill-blue-600" : "fill-gray-800"}`}
      />
      <span>{data}</span>
    </Button>
  );
}
